import { useMemo } from 'react';
import Rating from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/core/styles';
import { useAutoratingStore } from './Autorating.store';
import styles from 'assets/styles/training.module.scss';

const StyledRating = withStyles({
  iconHover: {
    height: '17px',
    width: '50px',
    transform: 'none',
  },
  iconFocus: {
    height: '17px',
    width: '50px',
    transform: 'none',
  },
})(Rating);

const RatingAI = ({ item_id, question_id, initialValue }) => {
  const tempEditFeedback = useAutoratingStore((state) => state?.tempEditFeedback);
  const editRating = useAutoratingStore((state) => state?.editRating);

  const value = useMemo(() => {
    if (!tempEditFeedback) return '';
    const index = tempEditFeedback.findIndex(
      (x) => x?.id_question === item_id && x?.id_feedback === question_id
    );
    return index === -1 ? '' : tempEditFeedback[index].answer.rating;
  }, [tempEditFeedback, item_id, question_id]);

  const isEditing = useMemo(() => {
    if (!tempEditFeedback) return false;
    return tempEditFeedback.some(
      (i) => i?.id_question === item_id && i?.id_feedback === question_id
    );
  }, [tempEditFeedback, item_id, question_id]);

  return (
    <>
      {isEditing ? (
        <StyledRating
          name={`unique-rating-IA${item_id}-${question_id}`}
          key={question_id}
          onChange={(e, newValue) => {
            editRating({ id: item_id, id_fdbk: question_id, rating: newValue });
          }}
          max={5}
          value={value}
          icon={<span className={styles.ratingItem}></span>}
        />
      ) : (
        <StyledRating
          name={`unique-rating-read-only-IA-${item_id}-${question_id}`}
          key={`AI- ${question_id}`}
          value={initialValue}
          icon={<span className={styles.ratingItem}></span>}
          style={{
            pointerEvents: 'none',
          }}
        />
      )}
      <span className={styles.ratingScore + ' heading5'}>{`${Number(
        isEditing ? value : initialValue || 0
      )}/5`}</span>
    </>
  );
};

export default RatingAI;
